
    module.exports = {
      render: function(){with(this){return _c('div',{attrs:{"id":"active-goal-objectives-report"}},[_c('vue-good-table',{attrs:{"columns":columns,"rows":teacher_goal_rows,"search-options":{enabled: true, placeholder: ''}}})],1)}},
      staticRenderFns: []
    };
  